import { transformEventLogCategoryToFormOption } from '../../entities/EventLog/EventLogTransformers'
import { CATEGORY_FILTERS } from '../../entities/NotificationCenter/NotificationCenter'
import { TypedDispatch } from '../store'
import {
    setCategories,
    setCategoryOptions,
    setError,
    setIsLoading,
} from './pzLogCategoriesReducer'

export const fetchPzLogCategories = () => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(''))

    try {
        const categoryOptions = CATEGORY_FILTERS.map(transformEventLogCategoryToFormOption)

        dispatch(setCategories(CATEGORY_FILTERS))
        dispatch(setCategoryOptions(categoryOptions))
    } catch (error) {
        console.error('[fetchPzLogCategories]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}
